import { useTranslation } from "react-i18next";
import { Desktop, Mobile } from '../../shared/components/Responsive';
import { TripItem } from "./TripItem";

export default function TripItemsList({ trips, editable = false, isLoading= false, endUser = false, translationFor, translationDetails, statusName}) {
    const { t } = useTranslation();

    return (<>
        <Mobile>
            <div className="flex flex-col gap-8">
                {trips.map((trip, index) => (
                    <TripItem key={index} endUser={endUser} trip={trip} editable={editable} isLoading={isLoading} translationFor={translationFor} translationDetails={translationDetails} statusName={statusName} />
                ))}
            </div>
        </Mobile>
        <Desktop>
            <table className="table-auto w-full rounded-lg overflow-hidden">
                <thead className="bg-gray-300 text-gray-600 h-[48px] text-lg">
                    <tr>
                        <th className="px-2">{t('account.date')}</th>
                        <th className="px-2">{t('account.status')}</th>
                        <th className="px-2">{t('account.reference')}</th>
                        <th className="px-2">{t('account.path')}</th>
                        <th className="px-2"></th>
                    </tr>
                </thead>
                <tbody className="bg-stone-100">
                    {trips.map((trip, index) => (
                        <TripItem key={index} endUser={endUser} trip={trip} editable={editable} isLoading={isLoading} translationFor={translationFor} statusName={statusName} />
                    ))}
                </tbody>
            </table>
        </Desktop>
    </>);
}
